import { sendBookingEnterpriseNotificationRequest } from "../../data/bookingEnterpriseNotificationApi";

export async function sendBookingEnterpriseNotificationUseCase(booking) {
  return await sendBookingEnterpriseNotificationRequest({
    vehicleType: 1,
    originLat: Number(booking.origin.lat),
    originLng: Number(booking.origin.lng),
  });
}
